export default __webpack_public_path__ + "static/media/blog.b83601c6.svg";